var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.75,
    cy: 7.58333,
    rx: 4.33333,
    ry: 4.33333,
    stroke: "#FF4C51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 22.75V20.5833C3.25 18.1901 5.1901 16.25 7.58333 16.25H11.9167C14.3099 16.25 16.25 18.1901 16.25 20.5833V22.75",
    stroke: "#FF4C51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 11.1666C16.9191 11.1666 16.5833 11.5024 16.5833 11.9166C16.5833 12.3308 16.9191 12.6666 17.3333 12.6666V11.1666ZM23.8333 12.6666C24.2475 12.6666 24.5833 12.3308 24.5833 11.9166C24.5833 11.5024 24.2475 11.1666 23.8333 11.1666V12.6666ZM21.3333 8.66663C21.3333 8.25241 20.9975 7.91663 20.5833 7.91663C20.1691 7.91663 19.8333 8.25241 19.8333 8.66663H21.3333ZM19.8333 15.1666C19.8333 15.5808 20.1691 15.9166 20.5833 15.9166C20.9975 15.9166 21.3333 15.5808 21.3333 15.1666H19.8333ZM17.3333 12.6666H23.8333V11.1666H17.3333V12.6666ZM19.8333 8.66663V15.1666H21.3333V8.66663H19.8333Z",
    fill: "#FF4C51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user-2.6d350bc0e7e767a28214729920f1d753.svg";
export { ForwardRef as ReactComponent };